module.exports = __webpack_public_path__ + "static/media/pintodamadrugada-partitura.0db2d6e0.png";